import { IFlightMarker } from "../apiFacades/bapi/flightMarkers";

export default function getFlightMarkerIcon(
  flightMarker: IFlightMarker,
): string {
  const { tsArchived } = flightMarker;

  if (tsArchived) {
    return `icon-gcp-transparent.svg`;
  }

  return `icon-gcp.svg`;
}
